import { parseFloat, parseNumber, transformModel } from '~/src/dash/api/resource-transforms';
import { IPillItem } from '~/src/dash/components/pill-switcher';

export interface IFlexibleBiddingThreshold {
  CPMThreshold: number;
  BidderPriority: number;
}

export const transformFlexibleBiddingThreshold = transformModel<IFlexibleBiddingThreshold>({
  CPMThreshold: parseFloat(['CPMThreshold']),
  BidderPriority: parseNumber(['BidderPriority']),
});

export enum FlexibleBiddingType {
  CPM = 0,
  CPM_PER_SECOND = 1,
}

export const flexibleBiddingTypeToString = (biddingType: FlexibleBiddingType): string => {
  if (biddingType === FlexibleBiddingType.CPM) {
    return 'CPM';
  }
  return 'CPM/S';
};

export const flexibleBiddingStringToType = (biddingTypeString: string): FlexibleBiddingType => {
  if (biddingTypeString === 'CPM') {
    return FlexibleBiddingType.CPM;
  }
  return FlexibleBiddingType.CPM_PER_SECOND;
};

export const FLEXIBLE_BIDDING_PILLS: IPillItem[] = [
  {
    text: flexibleBiddingTypeToString(FlexibleBiddingType.CPM),
  },
  {
    text: flexibleBiddingTypeToString(FlexibleBiddingType.CPM_PER_SECOND),
  },
];
